import React from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Stack,
  List,
  ListItem,
} from "@mui/material";
import { Link } from "react-router-dom";
import { blue } from "@mui/material/colors";

const CorpusNotes = ({ open, onClose }: {
  open: boolean,
  onClose: () => void
}) => {
  return (
    <Dialog open={open} onClose={onClose} scroll={"paper"} fullWidth maxWidth="lg">
      <DialogTitle>簡　介</DialogTitle>
      <DialogContent>
        <Stack>
          <div>
            <h3>一. 語料簡介</h3>
            <p>基督教文學</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 傳教士除了翻譯聖經外，還用粵語編寫基督教文學作品，包括主日學的教材、祈禱書以及介紹基督教教義的小說。本語料庫選取四個基督教文學作品：理雅各《落爐不燒》(184-?)；俾士《曉初訓道》(1862)；花波《述史淺譯》(1866)*；英為霖《辜蘇歷程》(1902)。另外本語料庫也收納尹士嘉的《教話指南》(1906)。《教話指南》是教外國人學說粵語的教科書，一共75課，其中第59、60、61課涉及到基督教和聖經的介紹，可以看到當時傳教士怎樣練習用粵語傳播基督教思想。《落爐不燒》、《曉初訓道》、《述史淺譯》、《辜蘇歷程》、《教話指南》分別都有牛津大學圖書館、加州大學、普林斯頓大學、澳洲國家圖書館、香港大學圖書館的網上公開版，本語料庫在每個作品的網頁上都有提供連結，以供觀眾參考。</p>

            <p>*本語料庫收納的《述史淺譯》是1888年重印版。</p>
            <p>&nbsp;</p>
            <h3>二. 本語料庫使用方法小提示：</h3>
            <p>方法一：您可選擇一種或多種早期粵語《路加福音》版本閱讀。</p>
            <p>方法二：您可選擇一個基督教文學作品後從頭閱讀。</p>
            <p>方法三：您可使用本語料庫的檢索功能來檢查某些詞在當時的用法。</p>
            <p>&nbsp;</p>
            <p>十九世紀的粵語與現時的粵語存在差異。相較十九世紀的粵語，150年後的現代粵語已變化頗多，用語有所不同。大家如有興趣，可透過本語料庫的檢索功能了解當時粵語的面貌。</p>
            <p>例如，您可查閱到不期同時的表達相同意義的詞語用法，例子如下表：</p>
            <table width={340} border={1} style={{textAlign: 'center'}}>
              <tbody>
                <tr>
                  <td width={170}>
                    <p><strong>十九世紀中</strong></p>
                  </td>
                  <td width={170}>
                    <p><strong>二十一世紀</strong></p>
                  </td>
                </tr>
                <tr>
                  <td width={170}>
                    <p>乜誰</p>
                  </td>
                  <td width={170}>
                    <p>邊個</p>
                  </td>
                </tr>
                <tr>
                  <td width={170}>
                    <p>嘵</p>
                  </td>
                  <td width={170}>
                    <p>咗</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>&nbsp;</p>
            <h3>三. 備註</h3>
            <p>以下為本語料庫原文中不常用字詞或異體字，與當前常用字詞或字義對照表：</p>
            <p><strong>字體對照表</strong></p>
            <table border={1} width={568} style={{textAlign: 'center'}}>
              <tbody>
                <tr>
                  <td>
                    <p><strong>聲母</strong></p>
                  </td>
                  <td width={155}>
                    <p><strong>原文用字</strong></p>
                  </td>
                  <td width={130}>
                    <p><strong>本語料庫中用字</strong></p>
                  </td>
                  <td width={226}>
                    <p><strong>現時常用字或常用字義</strong></p>
                  </td>
                </tr>
                <tr>
                  <td rowSpan={2} width={47}>
                    <p>ㅇ</p>
                  </td>
                  <td width={155}>
                    <p>𠮩</p>
                  </td>
                  <td width={130}>
                    <p>吖</p>
                  </td>
                  <td width={226}>
                    <p>吖 aa1（語氣助詞。）</p>
                  </td>
                </tr>
                <tr>
                  <td width={155}>&nbsp;</td>
                  <td width={130}>
                    <p>唉</p>
                  </td>
                  <td width={226}>
                    <p>唉 aai4（語氣助詞。）</p>
                  </td>
                </tr>
                <tr>
                  <td rowSpan={4} width={47}>
                    <p>b</p>
                  </td>
                  <td width={155}>
                    <p>嚊、𡀠</p>
                  </td>
                  <td width={130}>
                    <p>嚊、𡀠</p>
                  </td>
                  <td width={226}>
                    <p>嚊、𡀠 bei6，（意為：還是，連詞)</p>
                  </td>
                </tr>
                <tr>
                  <td width={155}>
                    <p>偪</p>
                  </td>
                  <td width={130}>
                    <p>偪</p>
                  </td>
                  <td width={226}>
                    <p>逼 bik1</p>
                  </td>
                </tr>
                <tr>
                  <td width={155}>
                    <p>𡃓</p>
                  </td>
                  <td width={130}>
                    <p>𡃓</p>
                  </td>
                  <td width={226}>
                    <p>噃 bo3（語氣助詞。）</p>
                  </td>
                </tr>
                <tr>
                  <td width={155}>
                    <p>蹼</p>
                  </td>
                  <td width={130}>
                    <p>蹼</p>
                  </td>
                  <td width={226}>
                    <p>蹼 buk6（意為「伏下」。）</p>
                  </td>
                </tr>
                <tr>
                  <td rowSpan={6} width={47}>
                    <p>d</p>
                  </td>
                  <td width={155}>
                    <p>撘</p>
                  </td>
                  <td width={130}>
                    <p>搭</p>
                  </td>
                  <td width={226}>
                    <p>答 daap3 （意為「回答」。）；</p>
                    <p>搭 daap3 （意為「粘上連接」。）</p>
                  </td>
                </tr>
                <tr>
                  <td width={155}>
                    <p>[口笪]</p>
                  </td>
                  <td width={130}>
                    <p>[口笪]</p>
                  </td>
                  <td width={226}>
                    <p>笪 daat6</p>
                  </td>
                </tr>
                <tr>
                  <td width={155}>
                    <p>[口躭]（高）</p>
                  </td>
                  <td width={130}>
                    <p>[口躭]（高）</p>
                  </td>
                  <td width={226}>
                    <p>擔（高）daam1</p>
                  </td>
                </tr>
                <tr>
                  <td width={155}>
                    <p>矴</p>
                  </td>
                  <td width={130}>
                    <p>矴</p>
                  </td>
                  <td width={226}>
                    <p>掟 deng3 （意為 「扔。」）</p>
                  </td>
                </tr>
                <tr>
                  <td width={155}>
                    <p>（個 / 呢）的</p>
                  </td>
                  <td width={130}>
                    <p>（個 / 呢）的</p>
                  </td>
                  <td width={226}>
                    <p>啲 di1</p>
                  </td>
                </tr>
                <tr>
                  <td width={155}>
                    <p>叚</p>
                  </td>
                  <td width={130}>
                    <p>段</p>
                  </td>
                  <td width={226}>
                    <p>段 dyun6</p>
                  </td>
                </tr>
                <tr>
                  <td rowSpan={2} width={47}>
                    <p>f</p>
                  </td>
                  <td width={155}>
                    <p>畨</p>
                  </td>
                  <td width={130}>
                    <p>番</p>
                  </td>
                  <td width={226}>
                    <p>番 faan1</p>
                  </td>
                </tr>
                <tr>
                  <td width={155}>
                    <p>𠵽唎㘔人</p>
                  </td>
                  <td width={130}>
                    <p>𠵽唎㘔人</p>
                  </td>
                  <td width={226}>
                    <p>法利賽人 faat3 lei6 coi3 jan4</p>
                  </td>
                </tr>
                <tr>
                  <td rowSpan={5} width={47}>
                    <p>g</p>
                  </td>
                  <td width={155}>
                    <p>𡃉</p>
                  </td>
                  <td width={130}>
                    <p>𡃉</p>
                  </td>
                  <td width={226}>
                    <p>㗎 gaa3</p>
                  </td>
                </tr>
                <tr>
                  <td width={155}>
                    <p>(豆)[口莢]</p>
                  </td>
                  <td width={130}>
                    <p>(豆) [口莢]</p>
                  </td>
                  <td width={226}>
                    <p>(豆)莢 gaap3</p>
                  </td>
                </tr>
                <tr>
                  <td width={155}>
                    <p>（失）𡄎</p>
                  </td>
                  <td width={130}>
                    <p>（失）𡄎</p>
                  </td>
                  <td width={226}>
                    <p>（失）𡄎 gam2（動詞後綴。）</p>
                  </td>
                </tr>
                <tr>
                  <td width={155}>
                    <p>㓤</p>
                  </td>
                  <td width={130}>
                    <p>㓤</p>
                  </td>
                  <td width={226}>
                    <p>拮；㓤 gat1</p>
                  </td>
                </tr>
                <tr>
                  <td width={155}>
                    <p>呌</p>
                  </td>
                  <td width={130}>
                    <p>叫</p>
                  </td>
                  <td width={226}>
                    <p>叫 giu3</p>
                  </td>
                </tr>
                <tr>
                  <td rowSpan={4} width={47}>
                    <p>j</p>
                  </td>
                  <td width={155}>
                    <p>(光)燄</p>
                  </td>
                  <td width={130}>
                    <p>(光)燄</p>
                  </td>
                  <td width={226}>
                    <p>(光)焰 jim6</p>
                  </td>
                </tr>
                <tr>
                  <td width={155}>
                    <p>(應)騐</p>
                  </td>
                  <td width={130}>
                    <p>(應)驗</p>
                  </td>
                  <td width={226}>
                    <p>(應)驗 jim6</p>
                  </td>
                </tr>
                <tr>
                  <td width={155}>
                    <p>[執/火]</p>
                  </td>
                  <td width={130}>
                    <p>熱</p>
                  </td>
                  <td width={226}>
                    <p>熱 jit6</p>
                  </td>
                </tr>
                <tr>
                  <td width={155}>
                    <p>喓</p>
                  </td>
                  <td width={130}>
                    <p>喓</p>
                  </td>
                  <td width={226}>
                    <p>喓 jiu1（意為「呼叫」。）</p>
                  </td>
                </tr>
                <tr>
                  <td rowSpan={3} width={47}>
                    <p>k</p>
                  </td>
                  <td width={155}>
                    <p>𢬿</p>
                  </td>
                  <td width={130}>
                    <p>𢬿</p>
                  </td>
                  <td width={226}>
                    <p>𢬿 kaai5，（意為：將；拿取，動詞。)</p>
                  </td>
                </tr>
                <tr>
                  <td width={155}>
                    <p>搇</p>
                  </td>
                  <td width={130}>
                    <p>搇</p>
                  </td>
                  <td width={226}>
                    <p>搇（意為：蓋上。）</p>
                  </td>
                </tr>
                <tr>
                  <td width={155}>
                    <p>(屋)𨀣</p>
                  </td>
                  <td width={130}>
                    <p>(屋)𨀣</p>
                  </td>
                  <td width={226}>
                    <p>(屋)企 kei2</p>
                  </td>
                </tr>
                <tr>
                  <td rowSpan={4} width={47}>
                    <p>l</p>
                  </td>
                  <td width={155}>
                    <p>[口扐]</p>
                  </td>
                  <td width={130}>
                    <p>[口扐]</p>
                  </td>
                  <td width={226}>
                    <p>[口扐] lak3（語氣助詞。）</p>
                  </td>
                </tr>
                <tr>
                  <td width={155}>
                    <p>㨆、[口冧]</p>
                  </td>
                  <td width={130}>
                    <p>冧</p>
                  </td>
                  <td width={226}>
                    <p>冧 lam3 （意為「倒塌」。）</p>
                  </td>
                </tr>
                <tr>
                  <td width={155}>
                    <p>甪</p>
                  </td>
                  <td width={130}>
                    <p>甪</p>
                  </td>
                  <td width={226}>
                    <p>甩 lat1</p>
                  </td>
                </tr>
                <tr>
                  <td width={155}>
                    <p>𥥅</p>
                  </td>
                  <td width={130}>
                    <p>𥥅</p>
                  </td>
                  <td width={226}>
                    <p>窿lung1</p>
                  </td>
                </tr>
                <tr>
                  <td rowSpan={4} width={47}>
                    <p>m</p>
                  </td>
                  <td width={155}>
                    <p>(細)伩(仔)</p>
                  </td>
                  <td width={130}>
                    <p>(細)蚊(仔)</p>
                  </td>
                  <td width={226}>
                    <p>(細)蚊(仔) man1</p>
                  </td>
                </tr>
                <tr>
                  <td width={155}>
                    <p>擝</p>
                  </td>
                  <td width={130}>
                    <p>擝</p>
                  </td>
                  <td width={226}>
                    <p>掹 mang1</p>
                  </td>
                </tr>
                <tr>
                  <td width={155}>
                    <p>𧴯</p>
                  </td>
                  <td width={130}>
                    <p>𧴯</p>
                  </td>
                  <td width={226}>
                    <p>孭 me1</p>
                  </td>
                </tr>
                <tr>
                  <td width={155}>
                    <p>(約)嗼</p>
                  </td>
                  <td width={130}>
                    <p>(約)嗼</p>
                  </td>
                  <td width={226}>
                    <p>(約)莫 mok2</p>
                  </td>
                </tr>
                <tr>
                  <td rowSpan={3} width={47}>
                    <p>n</p>
                  </td>
                  <td width={155}>
                    <p>𡀝</p>
                  </td>
                  <td width={130}>
                    <p>𡀝</p>
                  </td>
                  <td width={226}>
                    <p>腍 nam6（「瞓腍」，即「熟睡」。）</p>
                  </td>
                </tr>
                <tr>
                  <td width={155}>&nbsp;</td>
                  <td width={130}>
                    <p>&nbsp;[口膩]</p>
                  </td>
                  <td width={226}>
                    <p>呢 ne1 / ni1 （語氣助詞。）</p>
                  </td>
                </tr>
                <tr>
                  <td width={155}>
                    <p>[口佞] (轉)</p>
                  </td>
                  <td width={130}>
                    <p>[口佞](轉)</p>
                  </td>
                  <td width={226}>
                    <p>擰(轉) ning6</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>ng</p>
                  </td>
                  <td width={155}>
                    <p>𠼮</p>
                  </td>
                  <td width={130}>
                    <p>𠼮</p>
                  </td>
                  <td width={226}>
                    <p>𠼮；𠱓 ngai1，（意為「懇求」。）</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>p</p>
                  </td>
                  <td width={155}>
                    <p>(白)[口抱]</p>
                  </td>
                  <td width={130}>
                    <p>(白)泡</p>
                  </td>
                  <td width={226}>
                    <p>(白)泡 pou5</p>
                  </td>
                </tr>
                <tr>
                  <td rowSpan={2} width={47}>
                    <p>s</p>
                  </td>
                  <td width={155}>
                    <p>𢳜</p>
                  </td>
                  <td width={130}>
                    <p>𢳜</p>
                  </td>
                  <td width={226}>
                    <p>嘥saai1，（意為「浪費」。）</p>
                  </td>
                </tr>
                <tr>
                  <td width={155}>
                    <p>嘥</p>
                  </td>
                  <td width={130}>
                    <p>嘥</p>
                  </td>
                  <td width={226}>
                    <p>晒saai3，（意為「全」。）</p>
                  </td>
                </tr>
                <tr>
                  <td rowSpan={4} width={47}>
                    <p>w</p>
                  </td>
                  <td width={155}>
                    <p>𢫕</p>
                  </td>
                  <td width={130}>
                    <p>𢫕</p>
                  </td>
                  <td width={226}>
                    <p>𢫕 wing1 （同「扔」。）</p>
                  </td>
                </tr>
                <tr>
                  <td width={155}>
                    <p>噁</p>
                  </td>
                  <td width={130}>
                    <p>噁</p>
                  </td>
                  <td width={226}>
                    <p>嗚 wu1（意為「伏下」。 ）</p>
                  </td>
                </tr>
                <tr>
                  <td width={155}>
                    <p>囘</p>
                  </td>
                  <td width={130}>
                    <p>回</p>
                  </td>
                  <td width={226}>
                    <p>回 wui4</p>
                  </td>
                </tr>
                <tr>
                  <td width={155}>
                    <p>噲</p>
                  </td>
                  <td width={130}>
                    <p>噲</p>
                  </td>
                  <td width={226}>
                    <p>會 wui5</p>
                  </td>
                </tr>
                <tr>
                  <td width={47}>
                    <p>y</p>
                  </td>
                  <td width={155}>
                    <p>㖇𠺢</p>
                  </td>
                  <td width={130}>
                    <p>㖇𠺢</p>
                  </td>
                  <td width={226}>
                    <p>而家yi4 gaa1（意為「現在」。 ）</p>
                  </td>
                </tr>
                <tr>
                  <td rowSpan={4} width={47}>
                    <p>z</p>
                  </td>
                  <td width={155}>
                    <p>[口沉]</p>
                  </td>
                  <td width={130}>
                    <p>[口沉]</p>
                  </td>
                  <td width={226}>
                    <p>浸 zam6</p>
                  </td>
                </tr>
                <tr>
                  <td width={155}>
                    <p>贃</p>
                  </td>
                  <td width={130}>
                    <p>贃</p>
                  </td>
                  <td width={226}>
                    <p>賺 zan6</p>
                  </td>
                </tr>
                <tr>
                  <td width={155}>
                    <p>呮</p>
                  </td>
                  <td width={130}>
                    <p>呮</p>
                  </td>
                  <td width={226}>
                    <p>喞 zek1 （語氣助詞。）</p>
                  </td>
                </tr>
                <tr>
                  <td width={155}>
                    <p>(污)[口糟]</p>
                  </td>
                  <td width={130}>
                    <p>(污)糟</p>
                  </td>
                  <td width={226}>
                    <p>(污)糟 zou1</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p><strong>&nbsp;</strong></p>
            <h3>四. 參考資料</h3>
            <p>本語料庫收納的《落爐不燒》、《曉初訓道》、《述史淺譯》、《辜蘇歷程》、《教話指南》分別在牛津大學圖書館、加州大學、普林斯頓大學、澳洲國家圖書館、香港大學圖書館也有網上公開版。下面是這幾個圖書館提供的連結，以供用戶參考。注意本語料庫顯示的頁碼有時與這些圖書館的版本有出入。</p>
            <ul>
              <li><a href="https://iiif.bodleian.ox.ac.uk/iiif/viewer/b70d7e1c-f9ac-4392-8a31-1387bc807f7e/#?c=0&m=0&s=0&cv=0&r=0&xywh=-4030%2C0%2C13420%2C7217">《落爐不燒》</a></li>
              <li><a href="https://babel.hathitrust.org/cgi/pt?id=uc1.c079002722&view=page&seq=1&skin=2021">《曉初訓道》</a></li>
              <li><a href="https://dpul.princeton.edu/catalog/6682x658m">《述史淺譯》</a></li>
              <li><a href="http://nla.gov.au/nla.obj-299097263/view?partId=nla.obj-299098710">《辜蘇歷程》</a></li>
              <li><a href="https://digitalrepository.lib.hku.hk/catalog/x346g741g#?c=&m=&s=&cv=&xywh=-2768%2C-130%2C7034%2C2561">《教話指南》</a></li>
            </ul>
            <p><strong>&nbsp;</strong></p>
            <p>&nbsp;</p>
            <p><strong>&nbsp;</strong></p>
          </div>
        </Stack>
      </DialogContent>
      <DialogActions style={{ marginRight: 18 }}>
        <Button variant="outlined" onClick={onClose}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CorpusNotes;
